import { z } from 'zod';

/**
 * Uppercase alphanumeric only: bank transfer content is routinely stripped of
 * diacritics in transit, and SePay matches case-insensitively on a substring.
 * Minimum 4 characters so a keyword cannot match essentially every transaction,
 * which would re-create the empty-whitelist billing hazard by another route.
 */
export const KEYWORD_PATTERN = /^[A-Z0-9]{4,20}$/;

export const rotateKeywordSchema = z.object({
  keyword: z.string().regex(KEYWORD_PATTERN, 'Từ khóa phải là 4-20 ký tự IN HOA hoặc số, không dấu'),
});
export type RotateKeywordInput = z.infer<typeof rotateKeywordSchema>;

export const purgeKeywordSchema = z.object({
  keyword: z.string().regex(KEYWORD_PATTERN, 'Từ khóa không hợp lệ'),
});
export type PurgeKeywordInput = z.infer<typeof purgeKeywordSchema>;
